import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';

import { TasksPage, type TasksSearch } from '@/features/tasks/TasksPage';

/*
  The tasks board (ALS-538). `task` opens one task, and `new` with `customer` opens New task for a
  client, which is how the client page starts one. `.catch(undefined)` keeps a junk value in a
  hand-edited address from throwing the route. Who may see it is the rail's ViewTasks, which the
  app shell holds every page to.
*/
const tasksSearch = z.object({
    task: z.coerce.number().int().min(1).optional().catch(undefined),
    new: z.coerce.number().pipe(z.literal(1)).optional().catch(undefined),
    customer: z.coerce.number().int().min(1).optional().catch(undefined),
});

export const Route = createFileRoute('/_app/tasks')({
    validateSearch: (search): TasksSearch => tasksSearch.parse(search),
    component: TasksRoute,
});

function TasksRoute() {
    const search = Route.useSearch();
    const navigate = useNavigate();
    return (
        <TasksPage
            search={search}
            onSearchChange={(next) =>
                void navigate({ to: '/tasks', search: next, replace: true, resetScroll: false })
            }
        />
    );
}
